import config from '@/config/config';

import Index from '@/pages/config/system-access-profile/index.vue';
import List from '@/pages/config/system-access-profile/list/list.vue';
import View from '@/pages/config/system-access-profile/view/view.vue';
import New from '@/pages/config/system-access-profile/new/new.vue';
import Edit from '@/pages/config/system-access-profile/edit/edit.vue';

const modulePermission = config.modules.systemAccessProfile;

export default {
  path: '/system-access-profile',
  name: 'system-access-profile',
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: 'enabled_read',
  },
  children: [
    {
      path: 'list',
      name: 'system-access-profile-list',
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
    },
    {
      path: ':id',
      name: 'system-access-profile-view',
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
      props: true,
    },
    {
      path: 'new',
      name: 'system-access-profile-new',
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_create',
      },
    },
    {
      path: ':id/e',
      name: 'system-access-profile-edit',
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_edit',
      },
      props: true,
    },
  ],
};
